import { useTranslation } from 'react-i18next';
import { useQuery } from 'urql';

import { utils } from 'lib/utils';

import { HeaderViewer } from './data/HeaderViewer.query';

type CreditsProps = {
  isCollapsed: boolean;
};

// @todo remove this Credits component when we move to Tracks

export const Credits = ({ isCollapsed }: CreditsProps) => {
  const { t } = useTranslation();

  const [result] = useQuery({
    query: HeaderViewer,
  });

  const viewer = result.data?.viewer;
  const creditCount = viewer?.ConnectedTeam?.settings?.billing?.subscription?.credit?.remaining ?? 0;

  if (isCollapsed) {
    return null;
  }

  return (
    <div className="flex w-60 flex-col gap-2 px-3 opacity-100 transition-opacity starting:opacity-0">
      <div className="text-sm">
        {t('sections.navigation.creditBalance')}:{' '}
        <span className="font-medium">{utils.numberWithCommas(creditCount)}</span>
      </div>
    </div>
  );
};
